import { Archive, Building2, ClipboardCheck, LayoutDashboard, LogOut, UserCircle, UsersRound } from "lucide-react";
import { NavLink, Outlet, useLocation } from "react-router-dom";
import { useAuth } from "@/auth/AuthContext";
import "@/pages/mantab/Mantab.css";

const NAV = {
  master: [["/mantab", "Kelola Distribusi", LayoutDashboard], ["/mantab/kelola-distribusi", "Kelola Kegiatan", ClipboardCheck], ["/mantab/akun-bank", "Akun Bank", Building2]],
  admin: [["/mantab", "Kelola Distribusi", LayoutDashboard], ["/mantab/kelola-distribusi", "Kelola Kegiatan", ClipboardCheck], ["/mantab/akun-bank", "Akun Bank", Building2]],
  pt: [["/mantab", "Kelola Distribusi", LayoutDashboard], ["/mantab/kelola-distribusi", "Kelola Kegiatan", ClipboardCheck]],
  bank_admin: [["/mantab", "Kelola Distribusi", LayoutDashboard], ["/mantab/kelola-distribusi", "Kelola Kegiatan", ClipboardCheck], ["/mantab/akun-penyalur", "Akun Penyalur", UsersRound], ["/mantab/akun-saya", "Akun Saya", UserCircle]],
  bank_operator: [["/mantab/kelola-distribusi", "Kelola Kegiatan", ClipboardCheck], ["/mantab/akun-saya", "Akun Saya", UserCircle]],
};

export default function MantabLayout() {
  const { user, logout } = useAuth();
  const location = useLocation();
  const links = NAV[user?.role] || [];
  const canAccessPadma = ["master", "admin", "pt"].includes(user?.role);
  return (
    <div className="mantab-shell" data-testid="mantab-layout">
      <header className="mantab-header">
        <div className="mantab-brand" data-testid="mantab-brand">
          {canAccessPadma ? <NavLink to="/padma" className="mantab-logo-link" aria-label="Kembali ke Akses Layanan PADMA" title="Akses Layanan PADMA" data-testid="mantab-padma-home-link"><img src="/logo-padma-transparent.png" alt="Logo PADMA" data-testid="mantab-padma-logo" /></NavLink> : <img src="/logo-padma-transparent.png" alt="Logo PADMA" data-testid="mantab-padma-logo" />}
          <div><div className="mantab-brand-title"><span>MANTAB</span><i>PADMA</i></div><p data-testid="mantab-acronym">Manajemen Buku Tabungan bagi Mahasiswa KIPK Baru</p></div>
        </div>
        <div className="mantab-user">
          <span>{user?.nama_bank || user?.namapt || user?.display_name}</span>
          {!["bank_admin", "bank_operator"].includes(user?.role) && <NavLink to="/padma" data-testid="mantab-back-padma"><Archive size={14} /> PADMA</NavLink>}
          <button onClick={logout} data-testid="mantab-logout" title="Keluar"><LogOut size={16} /></button>
        </div>
      </header>
      <nav className="mantab-nav" aria-label="Navigasi MANTAB">
        {links.map(([to, label, Icon]) => <NavLink key={to} to={to} end={to === "/mantab"} data-testid={`mantab-nav-${to.split("/").pop() || "dashboard"}`} className={({ isActive }) => isActive ? "active" : ""}><Icon size={16} /> {label}</NavLink>)}
      </nav>
      <main className="mantab-main" data-route={location.pathname}><Outlet /></main>
    </div>
  );
}